import React from 'react';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import {pageFilter, getArtistCookie} from "../data/page_data";
import axios from "axios";
import {utilLoopHelper} from "../utils";
import PodcastItem from "../components/PodcastItem";
import {Howl, Howler} from 'howler';
import Loading from "../components/loading";
import CssLoader from '../components/CssLoader';
import {navigate} from '@reach/router';
import * as ReactGA from "react-ga";

class PodcastPage extends React.Component {

    constructor(props) {
        super(props);
        this.pageData = pageFilter(this.props.artist, '../');
        this.state = {}
    }

    componentDidMount() {
        axios.get('/w/api/' + this.pageData.artist.id + '/podcast',{headers:{
          PortalAuth: getArtistCookie(this.props.artist)
        }})
            .then(response => {
                var respData = response.data;
                this.setState(state => ({data: respData}));
            }).catch(error =>{
            document.location.href = "join";
            });
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    setCurrentAudio = (item) => {
        this.currentAudio = item;
    }

    stopCurrentAudio = () =>{
        if(this.currentAudio){
            this.currentAudio.stop();
        }
    }

    componentWillUnmount() {
        if(this.currentAudio){
            this.currentAudio.stop();
        }
    }

    render() {
        return (<>
        <CssLoader css={this.pageData.artist.css}/>
            <Navbar data={this.pageData} title="PODCAST"/>
            <div className="content podcast">
                <div className="home-podcast-wrapper">
                    {!this.state.data ? <Loading/> :
                    <div className="home-podcast">
                        <h2>Podcast {this.pageData.artist.name}</h2>
                        <div className="hp-inner">
                            <ul>
                                {
                                    utilLoopHelper(this.state.data.items, (item, index) =>{

                                        return <PodcastItem artist={this.props.artist}
                                                            key={'pdc' + index} data={item}
                                                            fnCurrentAudio={this.setCurrentAudio}
                                                            fnStopCurrentAudio={this.stopCurrentAudio}
                                        />
                                    } )
                                }

                            </ul>
                        </div>
                    </div>
                    }
                </div>
            </div>

            <Footer/>
        </>);
    }
}

export default PodcastPage;